import * as React from 'react';

import {ConstantContactEmailPreviewModal} from './constant-contact-email-preview-modal';

type State = {
    currentViewId: string | null | undefined;
};

export class ConstantContactPreviewListener extends React.PureComponent<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            currentViewId: null,
        };
    }

    componentDidMount() {
        if (typeof Peep !== 'undefined' && Peep.events) {
            $(window).on(
                Peep.events.openConstantContactEmailPreview,
                (_: React.SyntheticEvent<any>, id: string) => {
                    this.setState({currentViewId: id});
                }
            );
        }
    }

    componentWillUnmount() {
        if (typeof Peep !== 'undefined' && Peep.events) {
            $(window).off(Peep.events.openConstantContactEmailPreview);
        }
    }

    render() {
        if (this.state.currentViewId) {
            return (
                <ConstantContactEmailPreviewModal
                    onClose={() => {
                        this.setState({currentViewId: null});
                    }}
                    activityId={this.state.currentViewId}
                />
            );
        }

        return null;
    }
}
